import type { FC } from "react";

import { useCheckoutConfiguration } from "@jti/commerce/providers";
import { useSelector } from "@jti/store/reduxHooks";
import { LoyaltyReferralCode } from "@jti/ui";

import { PromoCode } from "@checkout/components/PromoCode";
import { SummaryCartItems } from "@checkout/components/SummaryCartItems";
import { SummarySubscription } from "@checkout/components/SummarySubscription";
import { CheckOutSteps } from "@checkout/constants/checkout-constants";
import { useFreeTrial } from "@checkout/hooks/useFreeTrial";
import { useOrder } from "@checkout/hooks/useOrder";
import { AsideLayout } from "@checkout/layouts/AsideLayout";
import { categorizeItems } from "@checkout/utils/categorizeItems";

import { OrderPaymentSummary } from "../OrderPaymentSummary";

import "../../../../components/CheckoutLoyaltyPoints/CheckoutLoyaltyPoints.scss";

type PaymentPageAsideProps = {
  submitButtonWrapperRef: React.RefObject<HTMLDivElement | null>;
};

export const PaymentPageAside: FC<PaymentPageAsideProps> = ({ submitButtonWrapperRef }) => {
  const { order, orderFetchStatus } = useOrder();
  const { isFreeTrial } = useFreeTrial();
  const checkoutConfiguration = useCheckoutConfiguration();
  const { loyalty } = checkoutConfiguration;
  const { isVisible } = useSelector((store) => store.cart.promoCode);

  const products = order?.items ?? [];
  const { standardItems, subscriptionItems } = categorizeItems(products);

  const onReferralCodeApplied = () => {
    window.location.href = window.location.href.split("#")[0];
  };

  const isPromoCodeVisible = !order && isVisible && !isFreeTrial;

  return (
    <>
      <AsideLayout
        data-testid="payment-page-aside"
        referralCodeSlot={
          !isFreeTrial && loyalty.showMgm ? (
            <LoyaltyReferralCode onCodeApplied={onReferralCodeApplied} source="checkout" />
          ) : null
        }
        slot1={isPromoCodeVisible ? <PromoCode step={CheckOutSteps.Payment} /> : null}
        slot3={<SummaryCartItems items={standardItems} isLoading={orderFetchStatus === "pending"} />}
        slot5={<SummarySubscription items={subscriptionItems} />}
        paymentSummarySlot={<OrderPaymentSummary />}
      />
      <div data-testid="aside-submit-button-wrapper" ref={submitButtonWrapperRef} />
    </>
  );
};
